import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { useUserContext} from '../../contexts/user-context';
import {Card, CardActionArea, CardContent, CardHeader, Grid, Typography} from "@mui/material";

const data = [
  { link: '/database/ambient-types', title: 'Ambient Types', more: 'Types selectable for Ambient components within a Campaign',permission:'ambienttypes.view' },
  {
    link: '/database/boroughs',
    title: 'Boroughs',
    more: 'Sub-divisions of London',
    permission:'regional.view'
  },
  { link: '/database/campaign-tags', title: 'Campaign Tags', more: 'Tagging for campaigns (currently previews)',permission:'campaigntags.view'},
  { link: '/database/client-company-groups', title: 'Client Company Groups', more: 'Group labels for client companies',permission:'companies.view'},
  { link: '/database/cost-supplier-categories', title: 'Cost Supplier Categories', more: 'Groups used for cost suppliers',permission:'campaigns.costs'},
  { link: '/database/cost-suppliers', title: 'Cost Suppliers', more: 'List of suppliers for cost purposes',permission:'campaigns.costs'},
  {
    link:'/database/distributors',
    title:'Distributors',
    more:'Distributors for area & panel bookings',
    permission:'distributors.view'
  },
  { link: '/database/experiential-types', title: 'Experiential Types', more: 'Types selectable for Experiential components within a Campaign',permission:'experientialtypes.view' },
  { link: '/database/landlords', title: 'Landlords', more: 'Landlords of sites',permission:'landlords.view' },
  { link: '/database/media-types', title: 'Media Types', more: 'Types of media used in the Campaign "Media Production" tab',permission:'mediatypes.view' },
  { link: '/database/packs', title: 'Packs', more: 'Site packs used to group sites and provide warnings',permission:'sites.view' },
  { link: '/database/other-types', title: 'Other Types', more: 'Types of "other" costs within a Campaign',permission:'othertypes.view' },
  { link: '/database/postersizes', title: 'Poster Sizes', more: 'Sizes of posters',permission:'postersizes.view' },
  { link: '/database/postersize-images', title: 'Poster Size Images', more: 'Sizes of posters',permission:'postersizes.view' },
  { link: '/database/regions', title: 'Regions', more: 'Regions (localities)',permission:'regional.view' },
  { link: '/database/region-types', title: 'Region Types', more: 'Region Types (areas)',permission:'regional.view' },
  { link: '/database/site-build-contractors',title: 'Site Build Contractors',more:'Companies used for site maintenance/build',permission:'sites.view'},
  { link: '/database/sitepricings', title: 'Site Pricings', more: 'Site rating used by sites and the relevant price(s).',permission:'sitepricing.view' },
  { link: '/database/site-tags', title: 'Site Tags', more: 'Site tags used to group sites',permission:'sites.view' },
  {
    link: '/database/sitestructures',
    title: 'Site Structures',
    more: <>Controls the list of Site Structures on the Site screen.<br/>When a full panel booking is made for a site, the poster size is taken from this table.</>,
    permission: 'sites.view'
  },
  {
    link: '/database/site-structure-types',
    title: 'Site Structure Types',
    more: 'Types of site structure (e.g. WM)',
    permission: 'sites.view'
  }
];

const Database = () => {
  const navigate = useNavigate();
  const toolbarContext = useContext(ToolbarContext);
  const user = useUserContext();
  const goto = (loc) => () => {
    navigate(loc);
  }
  useEffect(() => {
    toolbarContext.setToolbar(
      {
        primary: [],
        title: 'Settings',
        secondary: []
      });
  }, []);

  return (
    <div className="settings is-scrollable">
      <Grid container spacing={2} >
        {
          data.map((item) => {
            if(item.permission && !user.hasPermission(item.permission)) return null;
            return (
                <Grid item xs={12} md={4} key={item.link}>
            <Card sx={{height:'100%'}}>
              <CardActionArea sx={{height:'100%'}} onClick={goto(item.link)}>
              <CardHeader variant="h5" title={item.title} sx={{paddingBottom:0}}/>
                <CardContent>
                  {item.more}
                </CardContent>
              </CardActionArea>
            </Card>
                </Grid>
                  );
          })
        }
      </Grid>
    </div>
  );
}


export default Database;
